import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Icon, Label } from '../../atoms';
import { DropdownMenuItem, LetterAvatar } from '../../molecules';
import { Dropdown } from '../Dropdown';

import { ReactComponent as Logo } from '../../../assets/images/logo-sidebar.svg';

const StyledDropdownToggleContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  cursor: pointer;
`;

const StyledLabel = styled(Label)`
  cursor: pointer;
  margin-left: 8px;
`;

const OrganizationDropdown = ({
  className = null,
  currentOrganization,
  organizations,
  onSelect
}) => {
  const navigate = useNavigate();

  const handleOnSelect = (id) => {
    onSelect(id);
    navigate('/spaces');
  };

  const toggleComponent = useMemo(
    () => (
      <StyledDropdownToggleContainer>
        <Logo />
        <StyledLabel $color='var(--content-title)'>{currentOrganization?.displayName}</StyledLabel>
        {organizations?.length > 1 && (
          <Icon name='chevrons' color='var(--content-subtitle)' displaySize={16} />
        )}
      </StyledDropdownToggleContainer>
    ),
    [organizations, currentOrganization?.displayName]
  );

  if (organizations?.length === 1) {
    return toggleComponent;
  }

  return (
    <Dropdown
      className={className}
      menuStyle={{
        width: 228,
        top: 'calc(100% + 10px)',
        maxHeight: '500px',
        overflowY: 'auto',
        left: -10
      }}
      toggleComponent={toggleComponent}
    >
      {() =>
        organizations?.map((organization) => (
          <DropdownMenuItem
            key={organization.id}
            leftIcon={<LetterAvatar name={organization.name} />}
            onClick={() => handleOnSelect(organization.id)}
            rightIcon={
              organization.id === currentOrganization.id ? (
                <Icon name='check' displaySize={20} />
              ) : null
            }
          >
            {organization.name}
          </DropdownMenuItem>
        ))
      }
    </Dropdown>
  );
};

const organizationProps = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  displayName: PropTypes.string
});

OrganizationDropdown.propTypes = {
  className: PropTypes.string,
  currentOrganization: organizationProps.isRequired,
  organizations: PropTypes.arrayOf(organizationProps).isRequired,
  onSelect: PropTypes.func.isRequired
};

export { OrganizationDropdown };
